import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'
import { Tabs } from 'antd'

interface Props {
  awaiting?: boolean
}

export const DetailsContainer = styled.div`
  //width: 100%;
  // max-width: 1630px;
  padding: 0;
  margin: 0 auto;
  @media ${device.mobileMin} {
    padding: 0px 24px 0px 30px;
  }
`

export const BlockOfCards = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media ${device.smallScreen} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`

export const StyledTabs = styled(Tabs)`
  overflow: visible;
  padding-left: 0;
  @media ${device.smallScreen} {
    padding-left: 24px;
  }
  .ant-tabs-tab-btn {
    padding: 0px 8px 0 16px;
    @media ${device.smallScreen} {
      padding: 0px 16px 0 24px;
    }
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: ${variables.fontSize14};
    line-height: 21px;
  }
  .ant-tabs-ink-bar {
    background: ${colors.green};
  }
  .ant-tabs-nav {
    margin-bottom: 26px;
    @media ${device.smallScreen} {
      margin-bottom: 24px;
    }
  }
`

export const StyledTabsItem = styled(Tabs.TabPane)`
  color: ${colors.mainText};
`

export const TabName = styled.span`
  color: ${colors.mainText};
  margin-right: 8px;
`

export const Number = styled.span`
  color: ${(props: Props) =>
    props.awaiting ? colors.green : colors.greyTextBlackBg};
`

export const StyledList = styled.ul`
  width: 100%;
  padding-left: 0px;
`

export const Videos = styled.div`
  .ant-tabs-nav-more > span {
    display: none;
  }
  .ant-tabs-tab {
    padding: 11px 0px;
  }

  .ant-tabs-nav-list {
    border-bottom: 1px solid #eeeeee;
  }
  .ant-tabs-card > .ant-tabs-nav::before {
    display: none;
  }
  .ant-tabs-card .ant-tabs-tab,
  [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab {
    background: transparent;
    border-color: transparent;
  }
  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-nav-list {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after {
    box-shadow: none !important;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
  }
  padding: 20px 16px 16px 0px;

  @media ${device.smallScreen} {
    background-color: ${colors.white};
  }
`
